import EventEmitter from "events";
import * as EventTypeEnum  from "./event-type-enum";

class EventBus {
    constructor(params) {
        this.eventEmitter = new EventEmitter();
    }

    static staticClass = new EventBus();
    static sc = EventBus.staticClass;

    onEntityUpdated = ({ entityType, entityId, entityData }) =>
        this.eventEmitter.emit(EventTypeEnum.EntityUpdated, { entityId, entityType, entityData });

    onEntityCreated = ({ entityType, entityId, entityData }) =>
        this.eventEmitter.emit(EventTypeEnum.EntityCreated, { entityId, entityType, entityData });

    onEntityDeleted = ({ entityType, entityId }) =>
        this.eventEmitter.emit(EventTypeEnum.EntityDeleted, { entityId, entityType });
}

export default EventBus;